import { ChevronDown } from 'lucide-react';
import Footer from './footer';
import { useProducts } from '@/hooks/useProducts';

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { products, groupedProducts, isSpecialUser } = useProducts();

  return (
    <>
      <section className="h-screen flex flex-row bg-cover bg-center text-white bg-hero relative">
        <div className="container mx-auto h-full">
          <div className="flex flex-col justify-center max-w-3xl px-4 md:px-0 h-full">
            <p className="uppercase text-2xl font-bold mb-6">
              Gyűjts, Dönts és Élvezd az általad választott ajándékot!
            </p>
            <h1 className="text-5xl md:text-7xl font-bold font-heineken mb-6">
              Heineken Liga
            </h1>
            <p className="text-2xl">
              Gyűjtsd a vásárlásodért járó krediteket, és váltsd be azokat
              akkor- és arra amire szeretnéd. A döntés a Te kezedben van!
            </p>
          </div>
        </div>
        <div className="absolute bottom-6 left-0 right-0 flex justify-center">
          <a
            href="#products"
            className="animate-bounce"
            aria-label="Scroll to products"
          >
            <ChevronDown className="w-10 h-10 text-white" />
          </a>
        </div>
      </section>
      {children}
      <Footer
        productList={
          isSpecialUser ? groupedProducts.flatMap((g) => g.products) : products
        }
      />
    </>
  );
}
